var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2114 4618 c-243 -244 -449 -454 -458 -468 -42 -64 4 -152 82 -154 l42 -1 333 333 c183 182 335 332 340 332 4 0 7 -642 7 -1427 0 -1338 2 -1429 18 -1449 34 -43 79 -54 127 -32 58 26 55 -57 55 1488 0 781 3 1420 7 1420 5 0 157 -150 340 -332 329 -329 333 -333 374 -333 77 0 125 91 83 155 -18 26 -895 910 -904 910 -3 0 -204 -199 -446 -442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 1740 l0 -1740 1840 0 1840 0 0 1740 0 1740 -531 0 -531 0 -29 -29 c-41 -41 -41 -101 0 -142 l29 -29 431 0 431 0 -2 -1537 -3 -1538 -1635 0 -1635 0 -3 1538 -2 1537 431 0 431 0 29 29 c41 41 41 101 0 142 l-29 29 -531 0 -531 0 0 -1740z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShare);
export default __webpack_public_path__ + "static/media/ios_share.bf427dfd4f1a9c7e3b01950d35115c0e.svg";
export { ForwardRef as ReactComponent };